import { useEffect, useState } from "react"

import { Row, Col, FormSection } from "twyne-new.ui"

import { CodeEditor } from "@/components/CodeEditor"

import MessageContainer from './MessageContainer'
import TabItem from "./TabItem"
import TabSection from "./TabSection"
import props from "./props"

export default function ResponseTab({ data, containerMessage }) {
  const [body, setBody] = useState('');

  useEffect(() => {
    if (typeof data?.body === 'object') {
      setBody(JSON.stringify(data?.body, null, 2))
    } else if (typeof data?.body === 'string') {
      setBody(data?.body)
    }
  }, [data])

  if (!data) return <MessageContainer message={containerMessage} />

  return <Row>
    <TabItem
      label={<span>latency <small>(ms)</small></span>}
      value={data.latency}
      sm="4"
    />
    <TabItem label="status code" value={data.statusCode} sm="4" />
    <TabItem label="status Text" value={data.statusText} sm="4" />
    <Col size="12">
      <TabSection data={data.headers} title="Headers" />
    </Col>
    <Col size="12">
      <FormSection>Body</FormSection>
      <CodeEditor
        value={body}
        language="json"
        height="200px"
      />
    </Col>
  </Row>
}

ResponseTab.propTypes = props
ResponseTab.defaultProps = {}
